// Píxel de Meta del catálogo público. Cada negocio pone su ID en Configuración;
// si no hay ID, nada de esto se carga. Los eventos usan el id del producto como
// content_ids, que es el mismo id del feed (/feed/<slug>), así Meta los cruza
// con su catálogo de productos.

const FORMATO = /^[0-9]{6,20}$/;
let pixelActivo = null;

export const pixelValido = (id) => FORMATO.test(String(id || '').trim());

export function iniciarPixel(id) {
  const pixelId = String(id || '').trim();
  if (typeof window === 'undefined' || !FORMATO.test(pixelId)) return false;
  if (pixelActivo === pixelId) return true;
  if (!window.fbq) {
    // Código oficial de Meta (fbevents.js), sin la etiqueta <noscript>.
    const fbq = function (...args) {
      if (fbq.callMethod) fbq.callMethod(...args);
      else fbq.queue.push(args);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(s);
  }
  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
  pixelActivo = pixelId;
  return true;
}

// Conteo propio de Kontrol (sql/126): los mismos eventos, sumados por día en
// Supabase. No depende de Meta y sirve aunque el negocio no tenga píxel.
const SB_URL = process.env.REACT_APP_SUPABASE_URL || 'https://uiurunhsfkjfcchzylet.supabase.co';
const SB_KEY = process.env.REACT_APP_SUPABASE_KEY || 'sb_publishable_ad0PytGfHDE2sJ01_58RqA_m4B7v5n5';
// "Enviaron pedido" no se cuenta aquí: sale de los pedidos reales (metaAdsService).
const CONTADOS = ['PageView', 'ViewContent', 'AddToCart', 'InitiateCheckout'];
// Robots que abren el catálogo (el revisor de anuncios de Meta, buscadores, pruebas).
const ROBOT = /bot|crawl|spider|slurp|facebookexternalhit|externalads|headless|lighthouse|pagespeed|prerender/i;
let negocioConteo = null;

function contar(evento) {
  if (!negocioConteo || !CONTADOS.includes(evento)) return;
  if (typeof navigator !== 'undefined' && (ROBOT.test(navigator.userAgent || '') || navigator.webdriver)) return;
  try {
    // keepalive: llega aunque la clienta se vaya enseguida a WhatsApp.
    fetch(`${SB_URL}/rest/v1/rpc/contar_evento_catalogo`, {
      method: 'POST', keepalive: true,
      headers: { 'Content-Type': 'application/json', apikey: SB_KEY, Authorization: `Bearer ${SB_KEY}` },
      body: JSON.stringify({ p_negocio: negocioConteo, p_evento: evento }),
    }).catch(() => {});
  } catch (e) { /* sin conteo, el catálogo funciona igual */ }
}

// Empieza a contar las visitas de clientas de este negocio (una visita por carga).
export function iniciarConteo(negocioId) {
  if (!negocioId || negocioConteo === negocioId) return;
  negocioConteo = negocioId;
  contar('PageView');
}

// Evento estándar (ViewContent, AddToCart, Purchase…): lo cuenta Kontrol y lo
// recibe el píxel. No hace nada si no se inició (la dueña mirando su catálogo).
export function eventoPixel(nombre, datos = {}) {
  contar(nombre);
  if (!pixelActivo || typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', nombre, datos);
}

// Datos de un producto en el formato que espera Meta.
export function datosProducto(producto, valor, moneda) {
  return {
    content_ids: [producto.id],
    content_type: 'product',
    content_name: producto.nombre,
    content_category: producto.categoria || undefined,
    value: Number(valor) || 0,
    currency: moneda || 'HNL',
  };
}
